import { useHoneyGridApiFetch } from '@/queries/useHoneyGridApiFetch'
import { useQuery } from '@tanstack/react-query'

import { workspacesQueryKey } from './useWorkspaces'

import type { Workspace } from 'honeygrid-types'

export const workspaceQueryKey = (workspaceId: Workspace['uuid']) =>
	[...workspacesQueryKey(), workspaceId] as const

export const useWorkspaceById = (id: Workspace['uuid'] = '') => {
	const authFetch = useHoneyGridApiFetch()

	return useQuery<Workspace>({
		queryKey: workspaceQueryKey(id),
		queryFn: (): Promise<Workspace> => authFetch(`workspaces/${id}`),
		enabled: !!id,
	})
}
